<div class="sn-promo" data-test="promo-box">
  @if (!applied) {
    <form class="sn-promo-form" (submit)="submit($event)" novalidate>
      <label class="sn-promo-label" [for]="inputId">Have a code?</label>
      <div class="sn-promo-field">
        <input
          [id]="inputId"
          type="text"
          class="form-control cyber-input sn-promo-input"
          autocomplete="off"
          spellcheck="false"
          placeholder="Enter code"
          [value]="code"
          (input)="onInput($event)"
          [attr.aria-invalid]="errorKind === 'invalid' ? true : null"
          [attr.aria-describedby]="inputId + '-message'"
          data-test="promo-input"
        />
        <button
          type="submit"
          class="btn-cyber btn-cyber-secondary sn-promo-apply"
          [disabled]="!code.trim() || checking"
          data-test="promo-apply"
        >
          @if (checking) {
            <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
            <span>Checking&hellip;</span>
          } @else {
            <span>Apply</span>
          }
        </button>
      </div>
    </form>
  } @else {
    <div class="sn-promo-applied" data-test="promo-applied">
      <i class="fas fa-tag" aria-hidden="true"></i>
      <span><strong>{{ applied.code }}</strong> applied</span>
      <button type="button" class="sn-promo-remove" (click)="remove.emit()" data-test="promo-remove">
        Remove<span class="visually-hidden"> code {{ applied.code }}</span>
      </button>
    </div>
  }

  <p [id]="inputId + '-message'" class="sn-promo-message" aria-live="polite">
    @if (error) {
      <span
        class="sn-promo-error"
        [class.is-retry]="isRetryLater"
        [attr.data-test]="isRetryLater ? 'promo-retry' : 'promo-error'"
      >
        <i class="fas" [class.fa-clock]="isRetryLater" [class.fa-circle-exclamation]="!isRetryLater" aria-hidden="true"></i>
        {{ error }}
      </span>
    } @else if (applied) {
      <span class="sn-promo-note" data-test="promo-note">
        <i class="fas fa-circle-check" aria-hidden="true"></i>
        {{ applied.description }}
      </span>
    }
  </p>
</div>
